import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { HistoryLogTemplate } from 'themes/components';

function FulfillmentOrderHistoryLogListTemplate({ fulfillmentOrderHistoryLogViewStore }) {
	const { listStore } = fulfillmentOrderHistoryLogViewStore;
	return <HistoryLogTemplate listStore={listStore}></HistoryLogTemplate>;
}

export default defaultTemplate(FulfillmentOrderHistoryLogListTemplate);
